
type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
let columnList: Array<column> = [
    {
        prop: "purchase_time_text",
        label: "单据日期",
        width: 75,
    },
    {
        prop: "create_time_text",
        label: "制单时间",
        width: 75,
    },
    {
        prop: "reviewer_text",
        label: "制单人",
        width: 75,
    },
    {
        prop: "employee_text",
        label: "采购员",
        width: 75,
    },
    {
        prop: "supplier",
        label: "供应商",
        width: 75,
    },
    {
        prop: "mining_price",
        label: "采购金额",
        width: 75,
    },
    {
        prop: "number",
        label: "数量",
        width: 75,
    },
    {
        prop: "purchase_desc",
        label: "备注",
        width: 75,
    }
];
const purchaseColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 150,
    },
    {
        prop: "specification",
        label: "规格",
        width: 75,
    },
    {
        prop: "encoding",
        label: "编码",
        width: 75,
    },
    {
        prop: "mountings_type_p_name",
        label: "配件分类",
        width: 75,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 75,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 75,
    },
    {
        prop: "cost_price",
        label: "采购单价",
        width: 75,
    },
    {
        prop: "member",
        label: "数量",
        width: 75,
    },
    {
        prop: "total_price",
        label: "金额",
        width: 75,
    },
];
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList, getLibraryInfo, getPurchaseInfo, permissionList,
} from "@/api/http";


import {Request} from '@/api/request';
import {validateInput, validateClass} from "@/assets/js/formRules";
import {partsFormType} from "@/assets/types/common";
import {useRoute, useRouter} from 'vue-router'

export default defineComponent({
    name: "purchaseWarehousing",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['采购入库']);
        
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<parts>),
            total = ref(0),
            roleList = ref({} as any),
            loading = ref(true),
            type = ref(''),
            route: any = useRoute(),
            Router: any = useRouter(),
            // 筛选
            selectGroup = reactive({
                status: "",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pname: "",
                mountings_type_name: "",
                mountings_brand_name: "",
                search: ''
            }),
            select = reactive({
                mountings_ptype_data: [],
                mountings_type_data: [],
                reappearance_type_data: [],
                mountings_brand_data: [],
                mountings_unit_data: [],
            }),
            remote_loading = ref(false),
            screenParameter: any = reactive({
                status: 2,
                search: '',
                page: currentPage.value,
                pagesize: pageSize.value
            }),
            dialogFormVisible = ref(false),
            dialogTitle = ref("新增配件"),
            formRef = ref(null),
            form = ref({
                name: "",
                mountings_type_pid: null,
                mountings_type_id: null,
                cost_price: null,
                selling_price: null,
                price_lock: 1,
                mountings_brand_id: null,
                specification: "",
                encoding: null,
                unit_id: null,
                build_bonus_type: 1,
                build_bonus_price: null,
                sell_bonus_type: 1,
                sell_bonus_price: null,
                return_cash_plan: null,
                describe: "",
            } as partsFormType),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入配件名称', value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
                cost_price: [{required: true, message: '必填', trigger: "change"}],
                mountings_type_pid: [{required: true, message: '必填', trigger: "change"}],
                price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入成本价', value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        let handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                console.log(currentPage.value);
                let mydata = {
                    type:1,
                    role_name:'purchaseWarehousing',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                Request.axiosInstance({
                    url: 'adminapi/Warehouse/purchaseWarehousing',
                    data: {
                        ...screenParameter,
                        page: currentPage.value,
                        pagesize: pageSize.value
                    }
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    
                })
                
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(select, res?.content || {});
                    remote_loading.value = false;
                });
            },
            selectChange = (e: any, key: string): void => {
                // screenParameter[key] = e;
                getTableData();
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({search: e});
            },
            getSummaries = (param: any): Array<string> => {
                const {columns, data} = param;
                const sums: any = [];
                const propArr = [
                    "total_price",
                    "member"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        
                        if (column.property == "total_price") {
                            sums[index] = `¥${purchaseDetail.value.total_price}`;
                        }
                        if (column.property == "member") {
                            sums[index] = purchaseDetail.value.number;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            formSelectChange = (e: number) => {
                getSelectData({type_pid: e});
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            brandBlur = (type: boolean) => {
                if (type) {
                    if (!selectGroup.mountings_brand_name) {
                        getSelectData({});
                    }
                } else {
                    if (!form.value.mountings_brand_id) {
                        getSelectData({});
                    }
                }
            },
            columnChange = (
                item: partsFormType & { id: number; status: number },
                type: boolean
            ): void => {
                if (type) {
                    dialogTitle.value = "编辑配件";
                    isEdit.value = true;
                    dialogFormVisible.value = true;
                    let data: any = {...form.value, id: 0};
                    Object.keys(data).forEach((key) => {
                        data[key as formKey] = item[key as formKey];
                    });
                    form.value = data;
                    getSelectData({type_pid: form.value.mountings_type_pid});
                } else {
                    getSetManagement({
                        id: item.id,
                        status: item.status == 1 ? 0 : 1,
                    }).then((res) => getTableData());
                }
            },
            submitForm = (): void => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        if (isEdit.value) {
                            getManagementTableEdit(form.value).then((res) =>
                                getTableData()
                            );
                        } else {
                            getManagementTableAdd(form.value).then((res) =>
                                getTableData()
                            );
                        }
                    }
                    dialogFormVisible.value = !valid;
                });
            },
            
            _option = (url: string, data: any) => {
                Router.push({
                    path: url,
                    query: data
                })
            },
            _purchaseMarkin = (id: number, type: number) => {
                let str = type == 1 ? '确认要将此单据标记为待入库状态吗？' : '确认要将此单据标记为已入库状态吗？';
                if (confirm(str)) {
                    Request.axiosInstance({
                        url: 'adminapi/Warehouse/purchaseMarkin',
                        data: {purchase_id: id}
                    }).then((res: any) => {
                        getTableData()
                    })
                }
                
            };
        // 点击单据编号触发弹窗相关
        let detailTable = ref([] as Array<any>),
            purchaseDetail = ref([] as any),
            detaildia_show = ref(false),
            isMountings = ref(false),
            bindPurchaseInfo = (purchase_id: number) => {
                getPurchaseInfo({purchase_id}).then((res: any) => {
                    if (res.status == 200) {
                        let info = res.content.list;
                        if (info) {
                            let arr = [[
                                '单据编号',
                                info.purchaes_number,
                                '状态',
                                info.toexamine,
                                '单据日期',
                                info.purchase_time_text,
                                '供应商',
                                info.supplier,
                            ], [
                                '制单时间',
                                info.create_time_text,
                                '制单人',
                                info.admin,
                                '审核时间',
                                info.toexamine_time_text,
                                '审核人',
                                info.reviewer_text,
                            ], [
                                '采购员',
                                info.employee,
                                '采购类型',
                                info.purchase_type_name,
                                '关联单据',
                                info.purchaes_bill,
                                '实际采购单号',
                                info.purchase_sh,
                            ], [
                                '备注',
                                info.purchase_desc,
                            ]];
                            
                            detailTable.value = arr;
                            purchaseDetail.value = res.content.list;
                            detaildia_show.value = true;
                            if (res.content.list.data.length > 0) {
                                isMountings.value = true
                            }
                        }
                    }
                });
            };
        onMounted(() => {
            
            getTableData();
            
            
        });
        watch(dialogFormVisible, (newValue, oldValue) => {
            if (oldValue) {
                form.value = {
                    name: "",
                    mountings_type_pid: null,
                    mountings_type_id: null,
                    cost_price: null,
                    selling_price: null,
                    price_lock: 1,
                    mountings_brand_id: null,
                    specification: "",
                    unit_id: null,
                    encoding: null,
                    build_bonus_type: 1,
                    build_bonus_price: null,
                    sell_bonus_type: 1,
                    sell_bonus_price: null,
                    return_cash_plan: null,
                    describe: "",
                };
                isEdit.value = false;
                dialogTitle.value = "新增配件";
                (formRef.value as any).resetFields();
            }
        });
        
        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectGroup,
            select,
            remote_loading,
            dialogFormVisible,
            dialogTitle,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            brandBlur,
            columnChange,
            submitForm,
            type,
            _option,
            _purchaseMarkin,
            screenParameter,
            bindPurchaseInfo,
            detailTable,
            purchaseDetail,
            detaildia_show,
            isMountings,
            purchaseColumn,
            getSummaries,
            roleList
        };
    },
});
